export function initServiceAddDropdowns(root = document) {
  root.querySelectorAll(".service-add-part").forEach((part) => {
    if (part.dataset.serviceAddReady === "true") return;
    const head = part.querySelector(".service-add-head");
    const content = part.querySelector(".service-add-content");
    if (!head || !content) return;

    part.dataset.serviceAddReady = "true";
    content.hidden = head.getAttribute("aria-expanded") !== "true";
    part.classList.toggle("is-open", !content.hidden);

    head.addEventListener("click", () => {
      const isOpen = head.getAttribute("aria-expanded") === "true";
      head.setAttribute("aria-expanded", String(!isOpen));
      content.hidden = isOpen;
      part.classList.toggle("is-open", !isOpen);
    });
  });

  initServiceTabbars(root);
}

function initServiceTabbars(root = document) {
  root.querySelectorAll("[data-service-tabbar]").forEach((tabbar, tabbarIndex) => {
    if (tabbar.dataset.serviceTabbarReady === "true") return;
    const tabs = Array.from(tabbar.querySelectorAll("[data-service-tab-target]"));
    const panels = Array.from(tabbar.querySelectorAll("[data-service-tab-panel]"));
    const chipBar = tabbar.querySelector(".service-tabbar-chip-bar");
    if (!tabs.length || !panels.length) return;

    tabbar.dataset.serviceTabbarReady = "true";

    if (chipBar && !chipBar.id) {
      const firstTabId = tabs[0]?.id || `service-tabbar-${tabbarIndex}`;
      chipBar.id = `${firstTabId}-chip-bar`;
    }

    let controls = tabbar.querySelector(".service-tabbar-controls");
    if (chipBar && !controls) {
      controls = document.createElement("div");
      controls.className = "service-tabbar-controls";
      chipBar.before(controls);
      controls.append(chipBar);
    }

    let toggleButton = tabbar.querySelector(".service-tabbar-toggle");
    if (chipBar && !toggleButton) {
      toggleButton = document.createElement("button");
      toggleButton.className = "service-tabbar-toggle";
      toggleButton.type = "button";
      toggleButton.setAttribute("aria-expanded", "false");
      toggleButton.setAttribute("aria-controls", chipBar.id);

      const toggleLabel = document.createElement("span");
      toggleLabel.className = "service-tabbar-toggle-label";
      toggleLabel.setAttribute("data-service-tabbar-toggle-label", "");

      const toggleIcon = document.createElement("span");
      toggleIcon.className = "service-tabbar-toggle-icon";
      toggleIcon.setAttribute("aria-hidden", "true");

      toggleButton.append(toggleLabel, toggleIcon);
      controls?.insertBefore(toggleButton, chipBar);
    } else if (controls && toggleButton && toggleButton.parentElement !== controls) {
      controls.insertBefore(toggleButton, chipBar);
    }

    const toggleLabel = toggleButton?.querySelector("[data-service-tabbar-toggle-label]");
    if (toggleButton) tabbar.classList.add("has-menu-toggle");

    const getTabText = (tab) => {
      const langSelector = document.body.classList.contains("set-lang-en") ? ".lang-en" : ".lang-de";
      const localizedText = tab?.querySelector(langSelector)?.textContent || tab?.textContent || "";
      return localizedText.replace(/\s+/g, " ").trim();
    };

    const setMenuOpen = (isOpen) => {
      if (!toggleButton) return;
      tabbar.classList.toggle("is-menu-open", isOpen);
      toggleButton.setAttribute("aria-expanded", String(isOpen));
    };

    const updateToggleLabel = () => {
      if (!toggleLabel) return;
      const activeTab = tabs.find((tab) => tab.getAttribute("aria-selected") === "true") || tabs[0];
      toggleLabel.textContent = getTabText(activeTab);
    };

    const activateTab = (nextTab, shouldFocus = false) => {
      const targetId = nextTab?.dataset.serviceTabTarget || "";
      if (!targetId) return;

      tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.hidden = !isActive;
        panel.classList.toggle("is-active", isActive);
      });

      updateToggleLabel();

      if (shouldFocus) nextTab.focus({ preventScroll: true });
    };

    const currentTab = tabs.find((tab) => tab.getAttribute("aria-selected") === "true") || tabs[0];
    activateTab(currentTab);

    toggleButton?.addEventListener("click", () => {
      const isOpen = toggleButton.getAttribute("aria-expanded") === "true";
      setMenuOpen(!isOpen);
    });

    document.addEventListener("click", (event) => {
      if (!tabbar.contains(event.target)) setMenuOpen(false);
    });

    document.addEventListener("language:changed", () => {
      requestAnimationFrame(updateToggleLabel);
    });

    tabbar.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (toggleButton?.getAttribute("aria-expanded") !== "true") return;
      setMenuOpen(false);
      toggleButton.focus({ preventScroll: true });
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        activateTab(tab);
        setMenuOpen(false);
      });

      tab.addEventListener("keydown", (event) => {
        const key = event.key;
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (key === "ArrowLeft") nextIndex = index - 1;
        if (key === "ArrowRight") nextIndex = index + 1;
        if (key === "Home") nextIndex = 0;
        if (key === "End") nextIndex = tabs.length - 1;
        const wrappedIndex = (nextIndex + tabs.length) % tabs.length;
        activateTab(tabs[wrappedIndex], true);
      });
    });
  });
}
